import React, { PropTypes } from 'react';

const MarkerForm = ({ point, disabled }) => (
  <form className="ui form">
    <div className="ui fields">
      <div className="eight wide field">
        <label>Numéro</label>
        <input
          name="number"
          type="number"
          readOnly
          defaultValue={point.number}
        />
      </div>
      <div className="eight wide field">
        <label>Nom</label>
        <input
          name="name"
          type="text"
          defaultValue={point.name}
          readOnly={disabled}
        />
      </div>
    </div>
  </form>
);

MarkerForm.propTypes = {
  point: PropTypes.object.isRequired,
};

export default MarkerForm;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/components/forms/MarkerForm.js